import React from "react";

export default function AppLink({
  href,
  onClick,
  size = "md",
  leadingIcon = null,
  trailingIcon = null,
  className = "",
  children,
  ...props
}) {
  const classes = [
    "ds-link",
    size === "xs" ? "ds-link--xs" : "",
    size === "sm" ? "ds-link--sm" : "",
    size === "md" ? "ds-link--md" : "",
    size === "lg" ? "ds-link--lg" : "",
    !href && onClick ? "ds-link--button" : "",
    !href && !onClick ? "ds-link--static" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      {leadingIcon ? <span className="ds-link__icon ds-link__icon--leading">{leadingIcon}</span> : null}
      <span className="ds-link__label">{children}</span>
      {trailingIcon ? <span className="ds-link__icon ds-link__icon--trailing">{trailingIcon}</span> : null}
    </>
  );

  if (href) {
    return (
      <a className={classes} href={href} onClick={onClick} {...props}>
        {content}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" className={classes} onClick={onClick} {...props}>
        {content}
      </button>
    );
  }

  return (
    <span className={classes} {...props}>
      {content}
    </span>
  );
}
